import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Container, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

interface ClientErrorProps {
  errorNumber: number;
  errorMsg: string;
  shortTitle: string;
  escapeEntry?: ReactNode;
}

const DefaultEscapeEntry = 
  <Button
    color="primary"
    component={RouterLink}
    to="/"
    variant="outlined"
  >
    Back to Home
  </Button>

const ClientError: FC<ClientErrorProps> = ({
  errorNumber,
  errorMsg,
  shortTitle,
  escapeEntry = DefaultEscapeEntry,
}) => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  const captalizedShortTitle = shortTitle.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())

  return (
    <>
      <Helmet>
        <title>Error: {captalizedShortTitle} | OnData</title>
      </Helmet>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.paper',
          display: 'flex',
          minHeight: '100%',
          px: 3,
          py: 5,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            color="textPrimary"
            sx={{ mt: 0.5 }}
            variant={mobileDevice ? 'h4' : 'h1'}
          >
            {errorNumber}: {errorMsg}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Box
              alt="Under development"
              component="img"
              src={`/static/error/error401_${theme.palette.mode}.svg`}
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 400
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            {escapeEntry}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ClientError;
